import { EqualsFilterValueType } from '../EqualsFilter';
import { FilterInterface } from '../FilterInterface';
import { OneOfFilterValueType } from '../OneOFilter';
import { RangeFilterValueType } from '../RangeFilter';
import { FilterDeserializer } from './FilterDeserializer';

export type FilterValueType = EqualsFilterValueType | OneOfFilterValueType | RangeFilterValueType;

export class FilterEquipService {
    constructor(private readonly filterDeserializer: FilterDeserializer) {
    }

    /**
     * Set the value of the given Filter if the search parameters contain a value for the Filter's keyPath
     *
     * @param {FilterInterface<T>} filter
     * @param {URLSearchParams} searchParams
     * @return {FilterInterface<T>}
     */
    public equip<T extends FilterValueType>(
        filter: FilterInterface<T>,
        searchParams: URLSearchParams
    ): FilterInterface<T> {
        try {
            const result = this.filterDeserializer.deserializeFilterState(filter, searchParams);
            if (result.isSome()) {
                return filter.withValue(result.value).withActive(true);
            }
        } catch (e) {
            console.error(e);
        }
        return filter;
    }
}
